import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1a883d',
        secondary: '#007694',
        accent: '#156e31'
      }
    }
  }
})
